import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProviderQuickInfo extends Layout {
    panelProvider: Panel;
    sourceFuelInterfaceLookup: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
